import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import { GetRoles } from "./api/login.js";
// import {changehidder} from './utils/seal';
// import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
// NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ["/login","/print","/sealPrint"]; // no redirect whitelist
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();
  const hasToken = window.sessionStorage.getItem("token");
  // console.log(hasToken, 'hasToken');
  if (hasToken) {
    // to.path == '/home'
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/home" });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      let hasRoles = sessionStorage.getItem("hasRoles");
      // let hasRoles = store.state.roles && store.state.roles.length > 0;
      if (hasRoles) {
        next();
      } else {
        try {
          var roles = [];
          await GetRoles() 
          .then((res) => {
            roles = res.data.data;
            store.commit('setroles', roles)
           
          })
          .catch((res) => {
            console.log(res);
          });
        
          // const roles = [
          //   "homePage",
          //   "firstPage",
          //   "noticePage",
          //   "case",
          //   "myCase",
          //   "allCase",
          //   "draftCase",
          //   "controlCase",
          //   "filedCase",
          //   "bankrupt",
          //   "examine",
          //   "counsel",
          //   "conflict",
          //   "archive",
          //   "email",
          //   "set",
          //   "menuManagement",
          //   "user",
          //   "organization",
          //   "legalCounsel",
          //   "conflictCase",
          //   "conflictCounsel",
          //   "lendManage",
          //   "newConfirm",
          //   "archiveManage",
          //   "bankruptCase",
          //   "bankindex",
          //   "bankinput",
          //   "Bidinput",
          //   "seal",
          //   "Caseapprove",
          //   "Sealapprove",
          //   "Casedetail",
          //   "caseinput",
          //   "commitCase",
          //   "caseinfo",
          //   "casetext",
          //   "sealApply",
          //   "bankruptBid",
          //   "SealApprove",
          //   "SealApprovedetail",
          //   "sealrecord",
          //   "Sealdetail",
          //   "Bidrecord",
          //   "BidApprove",
          //   "BidApprovedetail",
          //   "BidApply",
          //   "Biddetail",
          //   "bankruptdetail",
          //   "bankruptfile",
          //   "newConfirm",
          // ];
          //  console.log("store.state.roles", store.state.roles);
          // const roles=store.state.roles
          // let roles = store.state.roles;
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            roles
          );
          accessRoutes.forEach((item) => {
            if(item.path=='seal'){
              item.children = changehidder(item.children)
            }
            if (item.redirect) {
              item.redirect = redirectF(item.path, item.children);
            
            }
            let val = item;
            router.addRoute("Home", val);
          });
          // console.log(accessRoutes)
          sessionStorage.setItem("hasRoles", "roles");
          next({ ...to, replace: true });
 
        } catch (error) {
          // console.log();
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("hasRoles");
          next("/login");
        }
      }
      // dynamically add accessible routes
      // router.addRoutes(accessRoutes)
    }
  } else {
    // next(`/login`)
    if (whiteList.indexOf(to.path) !== -1) {
      //
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`);
      NProgress.done();
    }
  }
});
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
function postRequest(url, params) {
  // let usp = new URLSearchParams(params)
  return new Promise(resolve => {
    axios({
      // headers: {
      //    'Content-Type': 'application/x-www-form-urlencoded'
      // },
      method: 'post',
      url,
      // data: Qs.stringify(params) //qs.stringify()将对象 序列化成URL的形式，以&进行拼接
      data:params,
    }).then(res => {
      resolve(res);
    })
  })
}
export function redirectF(menu, arr) {
  arr = arr.filter((el) => el.hidden != true);
  if (arr.length > 0) {
    return "/home/" + menu + "/" + arr[0].name;
  }
}

export function changehidder(arr){
  // console.log(arr.filter(el=>el.path=="SealApprove"))
  if(arr.filter(el=>el.path=="SealApprove").length<=0){
  
    var foundIndex = arr.findIndex(x => x.path == "sealrecord");
    if(foundIndex!=-1){
      arr[foundIndex].hidden= false;
      // console.log("seal")
    }
  }
  if(arr.filter(el=>el.path=='BidApprove').length<=0){
    var foundIndex = arr.findIndex(x => x.path == "Bidrecord");
    if(foundIndex!=-1){
      arr[foundIndex].hidden= false;
      // console.log("Bid")
    }
  }
  return arr
}